export default "__VITE_ASSET__CyMI3D1Y__"